import { Calendar, Inbox, LayoutDashboard, Menu, MessageCircle } from 'lucide-react';
import { TabsShell } from '../../components/TabsShell';
import { DriverDashboard } from './DriverDashboard';
import { DriverMore } from './DriverMore';
import { DriverProfilePage } from './DriverProfilePage';
import { AvailabilityPage } from './AvailabilityPage';
import { ServicesPage } from './ServicesPage';
import { SettingsPage } from './SettingsPage';
import { VehiclesPage } from './vehicles/VehiclesPage';
import { VehicleFormPage } from './vehicles/VehicleFormPage';
import { VehicleDetailPage } from './vehicles/VehicleDetailPage';
import { DocumentsPage } from './documents/DocumentsPage';
import { DocumentFormPage } from './documents/DocumentFormPage';
import { DocumentDetailPage } from './documents/DocumentDetailPage';
import { NotificationsPage, useUnreadNotifications } from '../common/NotificationsPage';
import { RideDetailPage } from '../common/RideDetailPage';
import { RequestsInboxPage } from './requests/RequestsInboxPage';
import { CalendarPage } from './calendar/CalendarPage';
import { ActiveRidePage } from './ActiveRidePage';
import { ReportsPage } from './ReportsPage';
import { InvitePage } from './InvitePage';
import { DriversAdminPage } from './DriversAdminPage';
import { CollectPaymentPage } from './payments/CollectPaymentPage';
import { TipsPage } from './payments/TipsPage';
import { PaymentsListPage } from '../common/PaymentsListPage';
import { ChatListPage, useChatUnread } from '../chat/ChatListPage';
import { ChatPage } from '../chat/ChatPage';
import { RecurringListPage } from '../recurring/RecurringListPage';
import { RecurringDetailPage } from '../recurring/RecurringDetailPage';
import { BlackoutsPage } from './calendar/BlackoutsPage';
import { DriverRequestDetailPage } from './requests/DriverRequestDetailPage';
import { DemandPage } from './DemandPage';
import { ClientDetailPage, ClientsPage } from './ClientsPage';
import { IncidentsPage } from './IncidentsPage';
import { CommissionsAdminPage, CommissionsPage } from './CommissionsPage';

const DriverNotifications = () => <NotificationsPage back="/driver/dashboard" />;
const DriverRide = () => <RideDetailPage role="driver" />;
const CollectByRide = () => <CollectPaymentPage />;
const CollectById = () => <CollectPaymentPage paymentIdParam />;
const DriverPayments = () => <PaymentsListPage role="driver" />;
const DriverChats = () => <ChatListPage base="/driver" />;
const DriverChat = () => <ChatPage base="/driver" />;
const DriverRecurring = () => <RecurringListPage base="/driver" />;
const DriverRecurringDetail = () => <RecurringDetailPage base="/driver" />;

export function DriverShell() {
  const unread = useUnreadNotifications();
  const chatUnread = useChatUnread();
  return (
    <TabsShell
      base="/driver"
      home="/driver/dashboard"
      tabs={[
        { tab: 'dashboard', href: '/driver/dashboard', label: 'Inicio', icon: LayoutDashboard },
        { tab: 'requests', href: '/driver/requests', label: 'Solicitudes', icon: Inbox },
        { tab: 'calendar', href: '/driver/calendar', label: 'Agenda', icon: Calendar },
        { tab: 'chat', href: '/driver/chat', label: 'Chat', icon: MessageCircle, badge: chatUnread.data?.count },
        { tab: 'more', href: '/driver/more', label: 'Más', icon: Menu, badge: unread.data?.count },
      ]}
      routes={[
        { path: '/driver/dashboard', component: DriverDashboard },
        { path: '/driver/requests', component: RequestsInboxPage },
        { path: '/driver/requests/:id', component: DriverRequestDetailPage },
        { path: '/driver/rides/:id/live', component: ActiveRidePage },
        { path: '/driver/rides/:id/payment', component: CollectByRide },
        { path: '/driver/payments', component: DriverPayments },
        { path: '/driver/payments/:id', component: CollectById },
        { path: '/driver/tips', component: TipsPage },
        { path: '/driver/reports', component: ReportsPage },
        { path: '/driver/invite', component: InvitePage },
        { path: '/driver/drivers', component: DriversAdminPage },
        { path: '/driver/demand', component: DemandPage },
        { path: '/driver/clients', component: ClientsPage },
        { path: '/driver/clients/:id', component: ClientDetailPage },
        { path: '/driver/incidents', component: IncidentsPage },
        { path: '/driver/commissions', component: CommissionsPage },
        { path: '/driver/commissions-admin', component: CommissionsAdminPage },
        { path: '/driver/recurring', component: DriverRecurring },
        { path: '/driver/recurring/:id', component: DriverRecurringDetail },
        { path: '/driver/chat', component: DriverChats },
        { path: '/driver/chat/:id', component: DriverChat },
        { path: '/driver/rides/:id', component: DriverRide },
        { path: '/driver/calendar', component: CalendarPage },
        { path: '/driver/blackouts', component: BlackoutsPage },
        { path: '/driver/more', component: DriverMore },
        { path: '/driver/notifications', component: DriverNotifications },
        { path: '/driver/profile', component: DriverProfilePage },
        { path: '/driver/availability', component: AvailabilityPage },
        { path: '/driver/services', component: ServicesPage },
        { path: '/driver/settings', component: SettingsPage },
        { path: '/driver/vehicles', component: VehiclesPage },
        { path: '/driver/vehicles/new', component: VehicleFormPage },
        { path: '/driver/vehicles/:id/edit', component: VehicleFormPage },
        { path: '/driver/vehicles/:id', component: VehicleDetailPage },
        { path: '/driver/documents', component: DocumentsPage },
        { path: '/driver/documents/new', component: DocumentFormPage },
        { path: '/driver/documents/:id/edit', component: DocumentFormPage },
        { path: '/driver/documents/:id', component: DocumentDetailPage },
      ]}
    />
  );
}
